import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import 'react-toastify/dist/ReactToastify.css';
import './i18n';
import './styles/global.css';
import App from './App';
import { CartProvider } from './context/CartContext';
import storeTheme from './theme/storeTheme';
const root = ReactDOM.createRoot(document.getElementById('root'));

if (typeof window !== 'undefined') {
  const query = new URLSearchParams(window.location.search);
  const pt = query.get('preview_tenant');
  if (pt) {
    sessionStorage.setItem('preview_tenant_slug', pt);
    sessionStorage.setItem('platform_preview_mode', 'true');
    const newUrl = window.location.pathname + window.location.search.replace(new RegExp('[?&]preview_tenant=' + pt), '').replace(/^&/, '?');
    window.history.replaceState({}, document.title, newUrl || '/');
  }
}


const I18nLoadingFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
    <CircularProgress />
  </Box>
);

root.render(
  <React.StrictMode>
    <Suspense fallback={<I18nLoadingFallback />}>
      <BrowserRouter>
        <HelmetProvider>
          <ThemeProvider theme={storeTheme}>
            <CssBaseline />
            <CartProvider>
              <App />
              <ToastContainer position="top-right" autoClose={2000} />
            </CartProvider>
          </ThemeProvider>
        </HelmetProvider>
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>
);
